import classes from "~/AddToCart/components/AddToCartProcess/Modals/CartSuccessModal/CartSuccessModal.module.less";
import { Stack, Typography } from "@mui/material";
import { ProductEntrySkeleton } from "./components/ProductEntrySkeleton";

interface Props {
  title: string;
}

export const RecommendationsSkeleton = ({ title }: Props) => {
  return (
    <div className={classes.recommended}>
      <Stack gap={1}>
        <Typography variant="titleMedium">{title}</Typography>

        <ProductEntrySkeleton />
        <ProductEntrySkeleton />
      </Stack>
    </div>
  );
};
